export const DELETE_WALLET_START = 'DELETE_WALLET_START';
export const DELETE_WALLET_SUCCESS = 'DELETE_WALLET_SUCCESS';
export const DELETE_WALLET_ERROR = 'DELETE_WALLET_ERROR';
export const DELETE_WALLET_END = 'DELETE_WALLET_END';
export const DELETE_WALLET_CLEAR = 'DELETE_WALLET_CLEAR';
